import { useCallback, useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { getDeductionStaffSummary } from "../services";
import { DeductionEmployeeSummary } from "../types/deduction.type";
import { COMPACT_QUERY } from "../utils/hooks/useCompact";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DeductionDetailsSkeleton from "../components/Deduction/Details/DeductionDetailsSkeleton";
import DeductionFooter from "../components/Deduction/Details/DeductionFooter";
import StaffSummary from "../components/Deduction/StaffSummary";

const compact = "@media " + COMPACT_QUERY;

export default function DeductionStaffSummaryPage() {
  const { staffUuid } = useParams<{ staffUuid: string }>();
  const [searchParams] = useSearchParams();
  const yearMonth = searchParams.get("year_month");
  const staffName = searchParams.get("name") ?? "";

  const [summary, setSummary] = useState<DeductionEmployeeSummary | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const onGetStaffSummary = useCallback(async () => {
    if (!staffUuid || !yearMonth) return;
    setLoading(true);
    try {
      const {
        data: { data },
      } = await getDeductionStaffSummary(staffUuid, dayjs(`${yearMonth}-01`));
      setSummary(data);
    } finally {
      setLoading(false);
    }
  }, [staffUuid, yearMonth]);

  useEffect(() => {
    onGetStaffSummary();
  }, [onGetStaffSummary]);

  if (loading) return <DeductionDetailsSkeleton />;

  return (
    <Box sx={{ padding: "8px 0", [compact]: { pb: "56px" } }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Link
          to="/report/deduction"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            รายงานการหักเงินพนักงาน
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          {summary?.fullname ?? staffName}
        </Typography>
      </Box>

      {summary && <StaffSummary summary={summary} />}

      {summary && <DeductionFooter totalAmount={summary.total_amount} />}
    </Box>
  );
}
